export const value = event => ['value', event.target.value]
export const checked = event => ['value', event.target.checked]


// WEBPACK FOOTER //
// ./src/formWizard/changeFunc.js